import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { errText } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) { toast.error("Le password non coincidono"); return; }
    if (pwd.length < 8) { toast.error("La password deve avere almeno 8 caratteri"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) { toast.error(errText(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAF8F5]">
      <div className="w-full max-w-sm eq-fade-up" data-testid="reset-password-page">
        <div className="flex items-center gap-2 mb-8">
          <img src="/icon-192.png" alt="Equiro" className="h-11 w-11 rounded-xl object-cover" />
          <span className="font-display font-extrabold text-2xl text-[#1B3B2B]">Equiro</span>
        </div>

        {!token ? (
          <div data-testid="reset-no-token">
            <h1 className="font-display text-2xl font-bold text-[#1B3B2B]">Link non valido</h1>
            <p className="text-[#5F6B64] mt-2">Il link di reset non è valido. Richiedine uno nuovo.</p>
            <Link to="/password-dimenticata" className="inline-block mt-6 text-[#8C532B] font-semibold" data-testid="go-forgot">
              Richiedi nuovo link
            </Link>
          </div>
        ) : done ? (
          <div className="text-center" data-testid="reset-done">
            <CheckCircle2 className="h-12 w-12 text-[#1B3B2B] mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold text-[#1B3B2B]">Password reimpostata</h1>
            <p className="text-[#5F6B64] mt-2">Ti reindirizziamo all'accesso…</p>
            <Link to="/login" className="inline-block mt-6 text-[#8C532B] font-semibold" data-testid="back-to-login">Vai all'accesso</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-bold text-[#1B3B2B]">Nuova password</h1>
            <p className="text-[#5F6B64] mt-1 mb-8">Scegli una nuova password per il tuo account.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="pwd">Nuova password</Label>
                <Input id="pwd" type="password" required value={pwd} data-testid="reset-password"
                  onChange={(e) => setPwd(e.target.value)} placeholder="min. 8 caratteri" className="mt-1.5" />
              </div>
              <div>
                <Label htmlFor="confirm">Conferma password</Label>
                <Input id="confirm" type="password" required value={confirm} data-testid="reset-confirm"
                  onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" className="mt-1.5" />
              </div>
              <Button type="submit" disabled={loading} data-testid="reset-submit"
                className="w-full bg-[#1B3B2B] hover:bg-[#142E1F] h-11">
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Reimposta password
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
